module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('subscription-form')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cd341b7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Subscription/Subscription.vue
// module id = 3684
// module chunks = 1